import { default as styled } from 'styled-components';

export const Main = styled.main`
  padding-bottom: 16px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    padding-bottom: 20px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
